export const TERMS_URL =
  process.env.EXPO_PUBLIC_TERMS_URL || "/terms.html";
export const PRIVACY_URL =
  process.env.EXPO_PUBLIC_PRIVACY_POLICY_URL || "/privacy-policy.html";
